import { render, staticRenderFns } from "./PriceTypes.vue?vue&type=template&id=4e0385ba"
import script from "./PriceTypes.vue?vue&type=script&lang=ts"
export * from "./PriceTypes.vue?vue&type=script&lang=ts"
import style0 from "./PriceTypes.vue?vue&type=style&index=0&id=4e0385ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports